import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "../../../helper/axios";
import { useUser } from "../../../Provider";
import { Helmet } from "react-helmet";
import { NavLink} from "react-router-dom";
import MUIDataTable from "mui-datatables";
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';


const ListViewBedType = () => {
  // Destructuring user details and functions from the context
  const { user, userHospitalcode, userrole1, isAuthRole, isAuthorized, gettokenId, token } = useUser();
  console.log(user, userHospitalcode, userrole1, isAuthRole, isAuthorized, gettokenId);

  // State variable to store bed type data
  const [data, setData] = useState([]);

  // Get the current date
  const currentDate = new Date();
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1; // Months are zero-indexed, so add 1
  const year = currentDate.getFullYear();
  // Format the date as DD-MM-YYYY
  const formattedDate = `${day}-${month}-${year}`;

  // State variable to store user role
  const [userRole, setRole] = useState();

  // useEffect to load bed type details on component mount or when dependencies change
  useEffect(() => {
    const loadData = async () => {
      await loadAllBeds();
    };

    loadData();
  }, [userHospitalcode, userrole1, isAuthorized]);

  // Function to fetch all bed type details
  const loadAllBeds = async () => {
    try {
      if (userHospitalcode !== undefined && userrole1 !== undefined) {
        console.log("userHospitalcode:", userHospitalcode);
        console.log("userrole1:", userrole1);
        const res = await axios.get("/GetBedTypes", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            hospitalcode: userHospitalcode,
            userrole: userrole1,
          },
        });
        setData(res.data);
        console.log(res.data);
      }
    } catch (error) {
      // Handle any error here.
      alert("Error loading bed type list:", error);
    }
  };

  // Function to delete a bed type
  const cancelBedType = async (bedtypeid) => {
    // Display a confirmation dialog
    const isConfirmed = window.confirm("Do you want to delete this bed type?");
  
    if (isConfirmed) {
      try {
        console.log("Bed Type ID:", bedtypeid);

        await axios.post(`/deletebedtype/${bedtypeid}`, null, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        // After successfully deleting the bed type, refresh the bed type list.
        loadAllBeds();
      } catch (error) {
        // Handle any error here.
        alert("Error deleting bed type:", error);
      }
    } else {
      // User clicked "Cancel" in the confirmation dialog, do nothing.
    }
  };

  // Define columns for MUI DataTable based on user authorization
  let columns;
  if (isAuthorized) {
    columns = [
      {
        name: "bedtype",
        label: "Bed Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "hospitalcode",
        label: "Hospital Code",
        options: {
          filter: true,
          sort: true,
          customBodyRender: (value) => (value !== null && value !== undefined) ? value.toString().padStart(5, '0') : ""
        },
      },
      {
        name: "",
        label: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            const newD = data.find((e) => {
              return (
                e.bedtype === tableMeta.rowData[0] &&
                e.hospitalcode === tableMeta.rowData[1]
              );
            });
            console.log('newD:', newD);
            return (
              <>

              <IconButton color="secondary" onClick={() => cancelBedType(newD.bedtypeid)}>
               <DeleteIcon />
             </IconButton>
                 <NavLink to={`/editbedtype/${newD.bedtypeid}`}>
                 <IconButton color="primary" >
                 <EditIcon />
               </IconButton>
                 </NavLink>
               </>
            );
          },
        },
      },
    ];
  } else {
    columns = [
      {
        name: "bedtype",
        label: "Bed Type",
        options: {
          filter: true,
          sort: true,
        },
      },
      {
        name: "",
        label: "Action",
        options: {
          customBodyRender: (value, tableMeta, updateValue) => {
            const newD = data.find((e) => {
              return (
                e.bedtype === tableMeta.rowData[0]
              );
            });
            console.log('newD:', newD);
            return (
              <>

             <IconButton color="secondary" onClick={() => cancelBedType(newD.bedtypeid)}>
              <DeleteIcon />
            </IconButton>
                <NavLink to={`/editbedtype/${newD.bedtypeid}`}>
                <IconButton color="primary" >
                <EditIcon />
              </IconButton>
                </NavLink>
              </>
            );
          },
        },
      },
    ];
  }

  // Options configuration for MUI DataTable
  const options = {
    selectableRows: false,
    onRowClick: ((props) => {
      console.log(props);
    }),
    downloadOptions: {
      filename: `Patient_list_${formattedDate}`,
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
    },
  };

  // Get the current domain for the page title
  const currentDomain = window.location.hostname;

  return (
    <>
      <Helmet>
        <title>Bed Type List | {currentDomain} | Hospital Management Software | Smart Solutions for Hospital Efficiency</title>
      </Helmet>
      {/* Navigation link to add bed type */}
      <NavLink to='/addbedtype'>
        <button className="btn btn-success btn-sm mr-2" style={{ margin: "10px" }}>
          <svg xmlns="http://www.w3.org/2000/svg" width="19" height="18" style={{ paddingRight: '4px' }} viewBox="0 0 100 100">
            <line x1="10" y1="50" x2="90" y2="50" stroke="white" stroke-width="10" />
            <line x1="50" y1="10" x2="50" y2="90" stroke="white" stroke-width="10" />
          </svg>
          Add Bed Type
        </button>
      </NavLink>
      {/* MUI DataTable for displaying bed type list */}
      <MUIDataTable
        title={"Bed Type List"}
        data={data}
        columns={columns}
        options={options}
        className="custom-mui-datatable"
      />
    </>
  );
};

export default ListViewBedType;